export default class AttributeTree {
    /**
     *
     * @param {Attribute} root
     */
    constructor(root = null) {
        this.root = root
    }

    /**
     * Deep-First traversal.
     *
     * @param {Attribute} node
     * @param callback
     */
    traverseDeepFirst(node, callback) {
        node = node || this.root

        node.getChildren().forEach(childNode => {
            this.traverseDeepFirst(childNode, callback);
        })

        callback(node);
    }

    /**
     * Breadth-First traversal.
     *
     * @param {Attribute} node
     * @param callback
     */
    traverseBreadthFirst(node, callback) {
        node = node || this.root

        callback(node);

        node.getChildren().forEach(childNode => {
            this.traverseBreadthFirst(childNode, callback);
        });
    }

    /**
     * Inserts a new node according to the parent id in the data object of the attribute node.
     * Returns true on success and false on failure, that is no node with the ID exists.
     *
     * @param {Attribute} newNode
     */
    insert(newNode) {
        if (this.root === null) {
            this.root = newNode
            return true
        } else {
            let inserted = false;

            this.traverseDeepFirst(this.root, (currentNode) => {
                if (currentNode.getId() === newNode.getParentId()) {
                    currentNode.insertChild(newNode);
                    inserted = true;
                }
            });

            return inserted
        }
    }

    /**
     * Returns the rood node of the Attribute Tree
     *
     * @returns {Attribute}
     */
    getRoot() {
        return this.root
    }

    /**
     * Filter the nodes by a given type
     *
     * @param key
     * @return {Array}
     */
    filterByType(key) {
        let result = [];

        this.traverseDeepFirst(null, (node) => {
            if (node.getDescription() === key) {
                result.push(node)
            }
        })

        return result.length === 1 ? result[0] : result
    }
}
